import store from '@/store'
import CONST from './const';
import Utils from './utils';

export default class imageBase64 {
  static async getImageBase64(image) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = this.parseBase64(reader.result); // 獲取轉換後的 Base64 字串
        const mimeType = image.type; // 獲取 MIME 類型
        resolve({ base64String, mimeType }); // 回傳 base64String 和 mimeType
      };
      reader.onerror = error => {
        reject(error); // 若發生錯誤，拒絕 Promise
      };

      reader.readAsDataURL(image); // 將圖片文件轉換為 Base64
    });
  }

  static parseBase64(base64String) {
    console.log(base64String)
    return base64String.split(',')[1]  //data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAHgAAA.....
  }
}